// extracted by mini-css-extract-plugin
export var bottom = "SideBar-module__bottom";
export var edge = "SideBar-module__edge";
export var error = "SideBar-module__error";
export var grow = "SideBar-module__grow";
export var input = "SideBar-module__input";
export var inputs = "SideBar-module__inputs";
export var noWrapRow = "SideBar-module__noWrapRow";
export var redo = "SideBar-module__redo";
export var root = "SideBar-module__root";
export var row = "SideBar-module__row";
export var section = "SideBar-module__section";
export var sep = "SideBar-module__sep";
export var strong = "SideBar-module__strong";
export var top = "SideBar-module__top";
export var undo = "SideBar-module__undo";
export var withUndo = "SideBar-module__withUndo";